import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import companies from "@/store/modules/companies";
import notify from "@/store/modules/notify";
import educationProtocol from "@/store/modules/educationProtocols/educationProtocol";
import listenerTable from "@/store/modules/listenerTable";
import users from "@/store/modules/users/users";
import user from "@/store/modules/users/currentUserInfo";
import courses from "@/store/modules/courses/courses";
import finalDocuments from "@/store/modules/final-documents/finalDocuments";
import showMore from "@/store/modules/show-more";
import lectures from "@/store/modules/lectures/lectures";
import docTemplates from "@/store/modules/doc-templates/doc-templates";
import tests from "@/store/modules/tests/index";
import contracts from "@/store/modules/contracts/contracts";
import taxonomy from "@/store/modules/taxonomy/index";
import homepage from "@/store/modules/homepage/index";
import webinars from "@/store/modules/webinars/webinars";
import records from "@/store/modules/records/records";
import validate from "@/store/modules/validate";
import fileManager from "@/store/modules/fileManager";
import companyUtils from "@/store/modules/companyUtils";

export default new Vuex.Store({
  state: {
    locale: undefined,
    screenWidth: 1980,
    studentLimit: 0,
    studentAmount: 0
  },
  actions: {},
  mutations: {
    SET_SCREEN_WIDTH(state: any, width: number) {
      state.screenWidth = width;
    },
    SET_LOCALIZATION(state: any, localization: string) {
      state.locale = localization;
    }
  },
  getters: {
    SCREEN_WIDTH(state: any) {
      return state.screenWidth;
    },
    LOCALIZATION(state: any) {
      return state.locale;
    },
    IS_BLOCK_ADD_STUDENTS(state) {
      return state.studentAmount >= state.studentLimit;
    }
  },

  modules: {
    companies,
    notify,
    educationProtocol,
    listenerTable,
    users,
    courses,
    docTemplates,
    finalDocuments,
    lectures,
    tests,
    contracts,
    showMore,
    taxonomy,
    homepage,
    webinars,
    records,
    validate,
    fileManager,
    companyUtils,
    user
  }
});
